// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2WiZU","title":"Header_title__16vpu","side":"Header_side__1vpm6"};